import React, { useContext, useEffect, useState } from "react";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Fieldset from "../../components/fieldset/Fieldset";
import TextFieldCustom from "../../components/basic/TextFieldCustom";
import SelectCustom from "../../components/basic/SelectCustom";
import { ReportERPContext } from "../../context/ReportERPContext";
import ExportExcel from "./ExportExcel";
import api from "../../services/api";

const currentYear = new Date().getFullYear();

const FilterReportERP = () => {
  const {
    cnpj,
    setCnpj,
    fantasy,
    setFantasy,
    base,
    setBase,
    typePromoter,
    setTypePromoter,
    year,
    setYear,
    mounth,
    setMounth,
    checkboxes,
    handleChange,
  } = useContext(ReportERPContext);
  const [optionsTypePromoter, setOptionsTypePromoter] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const getDataFilters = async () => {
      try {
        setLoading(true);
        const { data } = await api.get("/promotor/todos/tipo/promotor");

        if (data.success && Array.isArray(data.data)) {
          setOptionsTypePromoter(data.data);
        }

        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    };

    getDataFilters();
  }, []);

  const inputsFilter = [];
  inputsFilter.push(
    {
      component: (
        <TextFieldCustom
          mask="cnpj"
          key="cnpj"
          label="CNPJ"
          lg={3}
          value={cnpj}
          setValue={setCnpj}
        ></TextFieldCustom>
      ),
    },
    {
      component: (
        <TextFieldCustom
          key="fantasia"
          label="Fantasia"
          lg={4}
          value={fantasy}
          setValue={setFantasy}
        ></TextFieldCustom>
      ),
    },
    {
      component: (
        <TextFieldCustom
          key="base"
          label="Base"
          lg={4}
          value={base}
          setValue={setBase}
        ></TextFieldCustom>
      ),
    },
    {
      component: (
        <SelectCustom
          loading={loading}
          label="Tipo Promotor"
          keyObject="Nome"
          lg={3}
          value={typePromoter}
          setValue={setTypePromoter}
          key="select-type-promoter"
          optionsList={optionsTypePromoter}
        ></SelectCustom>
      ),
    },

    {
      component: (
        <SelectCustom
          loading={false}
          label="Mês"
          lg={2}
          value={mounth}
          setValue={setMounth}
          key="select-type-month"
          optionsList={[
            { id: 1, descricao: "Jan" },
            { id: 2, descricao: "Fev" },
            { id: 3, descricao: "Mar" },
            { id: 4, descricao: "Abr" },
            { id: 5, descricao: "Mai" },
            { id: 6, descricao: "Jun" },
            { id: 7, descricao: "Jul" },
            { id: 8, descricao: "Ago" },
            { id: 9, descricao: "Set" },
            { id: 10, descricao: "Out" },
            { id: 11, descricao: "Nov" },
            { id: 12, descricao: "Dez" },
          ]}
        ></SelectCustom>
      ),
    },
    {
      component: (
        <SelectCustom
          loading={false}
          label="Ano"
          lg={2}
          value={year}
          setValue={setYear}
          key="select-type-year"
          optionsList={[
            { descricao: currentYear.toString() },
            { descricao: (currentYear - 1).toString() },
            { descricao: (currentYear - 2).toString() },
          ]}
        ></SelectCustom>
      ),
    },
    {
      component: (
        <FormControlLabel
          key="checkbox-Base"
          lg={2}
          control={
            <Checkbox
              checked={checkboxes.Base}
              onChange={handleChange}
              name="Base"
              color="primary"
            />
          }
          label="Base"
        />
      ),
    },
    {
      component: (
        <FormControlLabel
          key="checkbox-Clientes"
          lg={2}
          control={
            <Checkbox
              checked={checkboxes.Clientes}
              onChange={handleChange}
              name="Clientes"
              color="primary"
            />
          }
          label="Clientes"
        />
      ),
    },
    {
      component: (
        <FormControlLabel
          lg={2}
          key="checkbox-Fornecedores"
          control={
            <Checkbox
              checked={checkboxes.Fornecedores}
              onChange={handleChange}
              name="Fornecedores"
              color="primary"
            />
          }
          label="Fornecedores"
        />
      ),
    },
    {
      component: (
        <FormControlLabel
          lg={2}
          key="checkbox-Produtos"
          control={
            <Checkbox
              checked={checkboxes.Produtos}
              onChange={handleChange}
              name="Produtos"
              color="primary"
            />
          }
          label="Produtos"
        />
      ),
    },
    {
      component: (
        <FormControlLabel
          lg={2}
          key="checkbox-Pedidos"
          control={
            <Checkbox
              checked={checkboxes.Pedidos}
              onChange={handleChange}
              name="Pedidos"
              color="primary"
            />
          }
          label="Pedidos"
        />
      ),
    },
    {
      component: (
        <FormControlLabel
          lg={2}
          key="checkbox-NFe"
          control={
            <Checkbox
              checked={checkboxes.NFe}
              onChange={handleChange}
              name="NFe"
              color="primary"
            />
          }
          label="NFe"
        />
      ),
    },
    {
      component: (
        <FormControlLabel
          lg={2}
          key="checkbox-NFSe"
          control={
            <Checkbox
              checked={checkboxes.NFSe}
              onChange={handleChange}
              name="NFSe"
              color="primary"
            />
          }
          label="NFSe"
        />
      ),
    },
    {
      component: (
        <FormControlLabel
          lg={2}
          key="checkbox-BoletoRec"
          control={
            <Checkbox
              checked={checkboxes.BoletoRec}
              onChange={handleChange}
              name="BoletoRec"
              style={{ color: checkboxes.BoletoRec ? "#43a047" : "gray" }}
            />
          }
          label="Boleto Rec."
        />
      ),
    },
    {
      component: (
        <FormControlLabel
          lg={2}
          key="checkbox-CCreditoRec"
          control={
            <Checkbox
              checked={checkboxes.CCreditoRec}
              onChange={handleChange}
              name="CCreditoRec"
              style={{ color: checkboxes.CCreditoRec ? "#43a047" : "gray" }}
            />
          }
          label="C. Crédito Rec."
        />
      ),
    },

    {
      component: (
        <FormControlLabel
          lg={2}
          key="checkbox-CDebitoRec"
          control={
            <Checkbox
              checked={checkboxes.CDebitoRec}
              onChange={handleChange}
              name="CDebitoRec"
              style={{ color: checkboxes.CDebitoRec ? "#43a047" : "gray" }}
            />
          }
          label="C. Débito Rec."
        />
      ),
    },

    {
      component: (
        <FormControlLabel
          lg={2}
          key="checkbox-DinheiroRec"
          control={
            <Checkbox
              checked={checkboxes.DinheiroRec}
              onChange={handleChange}
              name="DinheiroRec"
              style={{ color: checkboxes.DinheiroRec ? "#43a047" : "gray" }}
            />
          }
          label="Dinheiro TRF. Rec."
        />
      ),
    },

    {
      component: (
        <FormControlLabel
          lg={2}
          key="checkbox-BoletoPag"
          control={
            <Checkbox
              checked={checkboxes.BoletoPag}
              onChange={handleChange}
              name="BoletoPag"
              color="secondary"
            />
          }
          label="Boleto Pag."
        />
      ),
    },
    {
      component: (
        <FormControlLabel
          lg={2}
          key="checkbox-CCreditoPag"
          control={
            <Checkbox
              checked={checkboxes.CCreditoPag}
              onChange={handleChange}
              name="CCreditoPag"
              color="secondary"
            />
          }
          label="C. Crédito Pag."
        />
      ),
    },
    {
      component: (
        <FormControlLabel
          lg={2}
          key="checkbox-CDebitoPag"
          control={
            <Checkbox
              checked={checkboxes.CDebitoPag}
              onChange={handleChange}
              name="CDebitoPag"
              color="secondary"
            />
          }
          label="C. Débito Pag."
        />
      ),
    },
    {
      component: (
        <FormControlLabel
          lg={2}
          key="checkbox-DinheiroPag"
          control={
            <Checkbox
              checked={checkboxes.DinheiroPag}
              onChange={handleChange}
              name="DinheiroPag"
              color="secondary"
            />
          }
          label="Dinheiro TRF. Pag."
        />
      ),
    },
    {
      component: <ExportExcel />,
    }
  );

  return (
    <div style={{ marginBottom: 20 }}>
      <Fieldset inputs={inputsFilter} key="filter" />
    </div>
  );
};

export default FilterReportERP;
